export default __webpack_public_path__ + "static/media/template-default-image.647df7c3.png";